/**
 * POST /api/learning-log・GET /api/learning-log/today の呼び出し（08_client-state-machine.md §8.5）。
 */
import type { LearningLogPayload } from "./state.js";

function csrfHeader(): Record<string, string> {
  const token = document.querySelector<HTMLMetaElement>('meta[name="_csrf"]')?.content ?? "";
  const header = document.querySelector<HTMLMetaElement>('meta[name="_csrf-header"]')?.content ?? "";
  return token !== "" && header !== "" ? { [header]: token } : {};
}

/** POST /api/learning-log。HTTP 2xx なら true、それ以外・例外なら false。 */
export async function postLearningLog(payload: LearningLogPayload): Promise<boolean> {
  try {
    const response = await fetch("/api/learning-log", {
      method: "POST",
      headers: { "Content-Type": "application/json;charset=UTF-8", ...csrfHeader() },
      body: JSON.stringify({
        curriculumId: payload.curriculumId,
        activeHeading: payload.activeHeading,
      }),
      credentials: "same-origin",
      cache: "no-store",
      keepalive: true,
    });
    // レスポンスボディは読まない（{"ok":true} の中身を検証しない。06_error-handling.md C-06）。
    if (!response.ok && response.status === 400) {
      // 08_client-state-machine.md §7.4 手順 6.5 は「呼び出し側（index.ts）が 400 を検知して
      // 追加ログを出す」としているが、公開シグネチャ（§8.5）は boolean のみを返す設計であり
      // ステータスコードを呼び出し元に渡さない。Response を直接見られるここで代わりに出す
      // （観測されるログ内容は同一。呼び出し元は 06_error-handling.md C-05 の汎用デバッグログのみ出す）。
      console.warn("learning-log: サーバーがリクエストを拒否しました（400）");
    }
    return response.ok;
  } catch {
    return false;
  }
}

/** GET /api/learning-log/today。取得できなければ false（spec.md「取得失敗時はログなし扱い」）。 */
export async function fetchToday(): Promise<boolean> {
  try {
    const response = await fetch("/api/learning-log/today", {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
    });
    if (!response.ok) return false;
    const json: unknown = await response.json();
    return (
      typeof json === "object" && json !== null && (json as { hasLogToday?: unknown }).hasLogToday === true
    );
  } catch {
    return false;
  }
}
